// @ts-nocheck

export type RoomGetWithPropertyOwner = typeof RoomGetWithPropertyOwner[keyof typeof RoomGetWithPropertyOwner];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RoomGetWithPropertyOwner = {
  true: 'true',
  false: 'false',
} as const;
